/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedAgentIndexRouteImport } from './routes/_authenticated/agent/index'
import { Route as AuthenticatedAgentDocumentRouteImport } from './routes/_authenticated/agent/document'
import { Route as AuthenticatedAgentPolicyIndexRouteImport } from './routes/_authenticated/agent/policy/index'
import { Route as AuthenticatedAgentDocumentIndexRouteImport } from './routes/_authenticated/agent/document/index'
import { Route as AuthenticatedAgentApplicationIndexRouteImport } from './routes/_authenticated/agent/application/index'
import { Route as AuthenticatedAgentDocumentSettingsRouteImport } from './routes/_authenticated/agent/document/settings'
import { Route as AuthenticatedAgentDocumentSchemaEditRouteImport } from './routes/_authenticated/agent/document/schema-edit'
import { Route as AuthenticatedAgentDocumentExtractRouteImport } from './routes/_authenticated/agent/document/extract'
import { Route as AuthenticatedAgentDocumentAddRouteImport } from './routes/_authenticated/agent/document/add'
import { Route as AuthenticatedAgentApplicationSettingsRouteImport } from './routes/_authenticated/agent/application/settings'
import { Route as AuthenticatedAgentDocumentExtractIndexRouteImport } from './routes/_authenticated/agent/document/extract/index'
import { Route as AuthenticatedAgentDocumentExtractDocumentTypeIdRouteImport } from './routes/_authenticated/agent/document/extract/$documentTypeId'
import { Route as AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRouteImport } from './routes/_authenticated/agent/document/extract/$documentTypeId/index'
import { Route as AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRouteImport } from './routes/_authenticated/agent/document/extract/$documentTypeId/$sampleId'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAgentIndexRoute = AuthenticatedAgentIndexRouteImport.update({
  id: '/agent/',
  path: '/agent/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAgentDocumentRoute =
  AuthenticatedAgentDocumentRouteImport.update({
    id: '/agent/document',
    path: '/agent/document',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentPolicyIndexRoute =
  AuthenticatedAgentPolicyIndexRouteImport.update({
    id: '/agent/policy/',
    path: '/agent/policy/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentDocumentIndexRoute =
  AuthenticatedAgentDocumentIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAgentDocumentRoute,
  } as any)
const AuthenticatedAgentApplicationIndexRoute =
  AuthenticatedAgentApplicationIndexRouteImport.update({
    id: '/agent/application/',
    path: '/agent/application/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentDocumentSettingsRoute =
  AuthenticatedAgentDocumentSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAgentDocumentRoute,
  } as any)
const AuthenticatedAgentDocumentSchemaEditRoute =
  AuthenticatedAgentDocumentSchemaEditRouteImport.update({
    id: '/schema-edit',
    path: '/schema-edit',
    getParentRoute: () => AuthenticatedAgentDocumentRoute,
  } as any)
const AuthenticatedAgentDocumentExtractRoute =
  AuthenticatedAgentDocumentExtractRouteImport.update({
    id: '/extract',
    path: '/extract',
    getParentRoute: () => AuthenticatedAgentDocumentRoute,
  } as any)
const AuthenticatedAgentDocumentAddRoute =
  AuthenticatedAgentDocumentAddRouteImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AuthenticatedAgentDocumentRoute,
  } as any)
const AuthenticatedAgentApplicationSettingsRoute =
  AuthenticatedAgentApplicationSettingsRouteImport.update({
    id: '/agent/application/settings',
    path: '/agent/application/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAgentDocumentExtractIndexRoute =
  AuthenticatedAgentDocumentExtractIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAgentDocumentExtractRoute,
  } as any)
const AuthenticatedAgentDocumentExtractDocumentTypeIdRoute =
  AuthenticatedAgentDocumentExtractDocumentTypeIdRouteImport.update({
    id: '/$documentTypeId',
    path: '/$documentTypeId',
    getParentRoute: () => AuthenticatedAgentDocumentExtractRoute,
  } as any)
const AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute =
  AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAgentDocumentExtractDocumentTypeIdRoute,
  } as any)
const AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute =
  AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRouteImport.update({
    id: '/$sampleId',
    path: '/$sampleId',
    getParentRoute: () => AuthenticatedAgentDocumentExtractDocumentTypeIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agent/document': typeof AuthenticatedAgentDocumentRouteWithChildren
  '/agent': typeof AuthenticatedAgentIndexRoute
  '/agent/application/settings': typeof AuthenticatedAgentApplicationSettingsRoute
  '/agent/document/add': typeof AuthenticatedAgentDocumentAddRoute
  '/agent/document/extract': typeof AuthenticatedAgentDocumentExtractRouteWithChildren
  '/agent/document/schema-edit': typeof AuthenticatedAgentDocumentSchemaEditRoute
  '/agent/document/settings': typeof AuthenticatedAgentDocumentSettingsRoute
  '/agent/application': typeof AuthenticatedAgentApplicationIndexRoute
  '/agent/document/': typeof AuthenticatedAgentDocumentIndexRoute
  '/agent/policy': typeof AuthenticatedAgentPolicyIndexRoute
  '/agent/document/extract/$documentTypeId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRouteWithChildren
  '/agent/document/extract/': typeof AuthenticatedAgentDocumentExtractIndexRoute
  '/agent/document/extract/$documentTypeId/$sampleId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute
  '/agent/document/extract/$documentTypeId/': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agent': typeof AuthenticatedAgentIndexRoute
  '/agent/application/settings': typeof AuthenticatedAgentApplicationSettingsRoute
  '/agent/document/add': typeof AuthenticatedAgentDocumentAddRoute
  '/agent/document/schema-edit': typeof AuthenticatedAgentDocumentSchemaEditRoute
  '/agent/document/settings': typeof AuthenticatedAgentDocumentSettingsRoute
  '/agent/application': typeof AuthenticatedAgentApplicationIndexRoute
  '/agent/document': typeof AuthenticatedAgentDocumentIndexRoute
  '/agent/policy': typeof AuthenticatedAgentPolicyIndexRoute
  '/agent/document/extract': typeof AuthenticatedAgentDocumentExtractIndexRoute
  '/agent/document/extract/$documentTypeId/$sampleId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute
  '/agent/document/extract/$documentTypeId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_authenticated/agent/document': typeof AuthenticatedAgentDocumentRouteWithChildren
  '/_authenticated/agent/': typeof AuthenticatedAgentIndexRoute
  '/_authenticated/agent/application/settings': typeof AuthenticatedAgentApplicationSettingsRoute
  '/_authenticated/agent/document/add': typeof AuthenticatedAgentDocumentAddRoute
  '/_authenticated/agent/document/extract': typeof AuthenticatedAgentDocumentExtractRouteWithChildren
  '/_authenticated/agent/document/schema-edit': typeof AuthenticatedAgentDocumentSchemaEditRoute
  '/_authenticated/agent/document/settings': typeof AuthenticatedAgentDocumentSettingsRoute
  '/_authenticated/agent/application/': typeof AuthenticatedAgentApplicationIndexRoute
  '/_authenticated/agent/document/': typeof AuthenticatedAgentDocumentIndexRoute
  '/_authenticated/agent/policy/': typeof AuthenticatedAgentPolicyIndexRoute
  '/_authenticated/agent/document/extract/$documentTypeId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRouteWithChildren
  '/_authenticated/agent/document/extract/': typeof AuthenticatedAgentDocumentExtractIndexRoute
  '/_authenticated/agent/document/extract/$documentTypeId/$sampleId': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute
  '/_authenticated/agent/document/extract/$documentTypeId/': typeof AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agent/document'
    | '/agent'
    | '/agent/application/settings'
    | '/agent/document/add'
    | '/agent/document/extract'
    | '/agent/document/schema-edit'
    | '/agent/document/settings'
    | '/agent/application'
    | '/agent/document/'
    | '/agent/policy'
    | '/agent/document/extract/$documentTypeId'
    | '/agent/document/extract/'
    | '/agent/document/extract/$documentTypeId/$sampleId'
    | '/agent/document/extract/$documentTypeId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agent'
    | '/agent/application/settings'
    | '/agent/document/add'
    | '/agent/document/schema-edit'
    | '/agent/document/settings'
    | '/agent/application'
    | '/agent/document'
    | '/agent/policy'
    | '/agent/document/extract'
    | '/agent/document/extract/$documentTypeId/$sampleId'
    | '/agent/document/extract/$documentTypeId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_authenticated/agent/document'
    | '/_authenticated/agent/'
    | '/_authenticated/agent/application/settings'
    | '/_authenticated/agent/document/add'
    | '/_authenticated/agent/document/extract'
    | '/_authenticated/agent/document/schema-edit'
    | '/_authenticated/agent/document/settings'
    | '/_authenticated/agent/application/'
    | '/_authenticated/agent/document/'
    | '/_authenticated/agent/policy/'
    | '/_authenticated/agent/document/extract/$documentTypeId'
    | '/_authenticated/agent/document/extract/'
    | '/_authenticated/agent/document/extract/$documentTypeId/$sampleId'
    | '/_authenticated/agent/document/extract/$documentTypeId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/agent/': {
      id: '/_authenticated/agent/'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AuthenticatedAgentIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/document': {
      id: '/_authenticated/agent/document'
      path: '/agent/document'
      fullPath: '/agent/document'
      preLoaderRoute: typeof AuthenticatedAgentDocumentRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/policy/': {
      id: '/_authenticated/agent/policy/'
      path: '/agent/policy'
      fullPath: '/agent/policy'
      preLoaderRoute: typeof AuthenticatedAgentPolicyIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/document/': {
      id: '/_authenticated/agent/document/'
      path: '/'
      fullPath: '/agent/document/'
      preLoaderRoute: typeof AuthenticatedAgentDocumentIndexRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentRoute
    }
    '/_authenticated/agent/application/': {
      id: '/_authenticated/agent/application/'
      path: '/agent/application'
      fullPath: '/agent/application'
      preLoaderRoute: typeof AuthenticatedAgentApplicationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/document/settings': {
      id: '/_authenticated/agent/document/settings'
      path: '/settings'
      fullPath: '/agent/document/settings'
      preLoaderRoute: typeof AuthenticatedAgentDocumentSettingsRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentRoute
    }
    '/_authenticated/agent/document/schema-edit': {
      id: '/_authenticated/agent/document/schema-edit'
      path: '/schema-edit'
      fullPath: '/agent/document/schema-edit'
      preLoaderRoute: typeof AuthenticatedAgentDocumentSchemaEditRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentRoute
    }
    '/_authenticated/agent/document/extract': {
      id: '/_authenticated/agent/document/extract'
      path: '/extract'
      fullPath: '/agent/document/extract'
      preLoaderRoute: typeof AuthenticatedAgentDocumentExtractRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentRoute
    }
    '/_authenticated/agent/document/add': {
      id: '/_authenticated/agent/document/add'
      path: '/add'
      fullPath: '/agent/document/add'
      preLoaderRoute: typeof AuthenticatedAgentDocumentAddRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentRoute
    }
    '/_authenticated/agent/application/settings': {
      id: '/_authenticated/agent/application/settings'
      path: '/agent/application/settings'
      fullPath: '/agent/application/settings'
      preLoaderRoute: typeof AuthenticatedAgentApplicationSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/agent/document/extract/': {
      id: '/_authenticated/agent/document/extract/'
      path: '/'
      fullPath: '/agent/document/extract/'
      preLoaderRoute: typeof AuthenticatedAgentDocumentExtractIndexRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentExtractRoute
    }
    '/_authenticated/agent/document/extract/$documentTypeId': {
      id: '/_authenticated/agent/document/extract/$documentTypeId'
      path: '/$documentTypeId'
      fullPath: '/agent/document/extract/$documentTypeId'
      preLoaderRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentExtractRoute
    }
    '/_authenticated/agent/document/extract/$documentTypeId/': {
      id: '/_authenticated/agent/document/extract/$documentTypeId/'
      path: '/'
      fullPath: '/agent/document/extract/$documentTypeId/'
      preLoaderRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRoute
    }
    '/_authenticated/agent/document/extract/$documentTypeId/$sampleId': {
      id: '/_authenticated/agent/document/extract/$documentTypeId/$sampleId'
      path: '/$sampleId'
      fullPath: '/agent/document/extract/$documentTypeId/$sampleId'
      preLoaderRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRouteImport
      parentRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRoute
    }
  }
}

interface AuthenticatedAgentDocumentExtractDocumentTypeIdRouteChildren {
  AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute
  AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute
}

const AuthenticatedAgentDocumentExtractDocumentTypeIdRouteChildren: AuthenticatedAgentDocumentExtractDocumentTypeIdRouteChildren =
  {
    AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute:
      AuthenticatedAgentDocumentExtractDocumentTypeIdSampleIdRoute,
    AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute:
      AuthenticatedAgentDocumentExtractDocumentTypeIdIndexRoute,
  }

const AuthenticatedAgentDocumentExtractDocumentTypeIdRouteWithChildren =
  AuthenticatedAgentDocumentExtractDocumentTypeIdRoute._addFileChildren(
    AuthenticatedAgentDocumentExtractDocumentTypeIdRouteChildren,
  )

interface AuthenticatedAgentDocumentExtractRouteChildren {
  AuthenticatedAgentDocumentExtractDocumentTypeIdRoute: typeof AuthenticatedAgentDocumentExtractDocumentTypeIdRouteWithChildren
  AuthenticatedAgentDocumentExtractIndexRoute: typeof AuthenticatedAgentDocumentExtractIndexRoute
}

const AuthenticatedAgentDocumentExtractRouteChildren: AuthenticatedAgentDocumentExtractRouteChildren =
  {
    AuthenticatedAgentDocumentExtractDocumentTypeIdRoute:
      AuthenticatedAgentDocumentExtractDocumentTypeIdRouteWithChildren,
    AuthenticatedAgentDocumentExtractIndexRoute:
      AuthenticatedAgentDocumentExtractIndexRoute,
  }

const AuthenticatedAgentDocumentExtractRouteWithChildren =
  AuthenticatedAgentDocumentExtractRoute._addFileChildren(
    AuthenticatedAgentDocumentExtractRouteChildren,
  )

interface AuthenticatedAgentDocumentRouteChildren {
  AuthenticatedAgentDocumentAddRoute: typeof AuthenticatedAgentDocumentAddRoute
  AuthenticatedAgentDocumentExtractRoute: typeof AuthenticatedAgentDocumentExtractRouteWithChildren
  AuthenticatedAgentDocumentSchemaEditRoute: typeof AuthenticatedAgentDocumentSchemaEditRoute
  AuthenticatedAgentDocumentSettingsRoute: typeof AuthenticatedAgentDocumentSettingsRoute
  AuthenticatedAgentDocumentIndexRoute: typeof AuthenticatedAgentDocumentIndexRoute
}

const AuthenticatedAgentDocumentRouteChildren: AuthenticatedAgentDocumentRouteChildren =
  {
    AuthenticatedAgentDocumentAddRoute: AuthenticatedAgentDocumentAddRoute,
    AuthenticatedAgentDocumentExtractRoute:
      AuthenticatedAgentDocumentExtractRouteWithChildren,
    AuthenticatedAgentDocumentSchemaEditRoute:
      AuthenticatedAgentDocumentSchemaEditRoute,
    AuthenticatedAgentDocumentSettingsRoute:
      AuthenticatedAgentDocumentSettingsRoute,
    AuthenticatedAgentDocumentIndexRoute: AuthenticatedAgentDocumentIndexRoute,
  }

const AuthenticatedAgentDocumentRouteWithChildren =
  AuthenticatedAgentDocumentRoute._addFileChildren(
    AuthenticatedAgentDocumentRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAgentDocumentRoute: typeof AuthenticatedAgentDocumentRouteWithChildren
  AuthenticatedAgentIndexRoute: typeof AuthenticatedAgentIndexRoute
  AuthenticatedAgentApplicationSettingsRoute: typeof AuthenticatedAgentApplicationSettingsRoute
  AuthenticatedAgentApplicationIndexRoute: typeof AuthenticatedAgentApplicationIndexRoute
  AuthenticatedAgentPolicyIndexRoute: typeof AuthenticatedAgentPolicyIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAgentDocumentRoute: AuthenticatedAgentDocumentRouteWithChildren,
  AuthenticatedAgentIndexRoute: AuthenticatedAgentIndexRoute,
  AuthenticatedAgentApplicationSettingsRoute:
    AuthenticatedAgentApplicationSettingsRoute,
  AuthenticatedAgentApplicationIndexRoute:
    AuthenticatedAgentApplicationIndexRoute,
  AuthenticatedAgentPolicyIndexRoute: AuthenticatedAgentPolicyIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
